import { ICommand, IDefineCommand, IQuery } from 'core-ts-types';
import { LargeCourseGroupSearchResultModel } from '../models/large_course_group_search_result_model';

angular
  .module('capability-ng-academic-planner')
  .factory(
    'clearLargeCourseGroupSearchResultCommand',
    function clearLargeCourseGroupSearchResultCommandDefinition(
      ngLargeCourseGroupSearchResultModel: LargeCourseGroupSearchResultModel,
      defineCommandORM: IDefineCommand
    ): ICommand {
      return defineCommandORM(
        'clearLargeCourseGroupSearchResultCommand',
        function clearLargeCourseGroupSearchResultCommand(deferred: ng.IDeferred<IQuery[]>): void {
          ngLargeCourseGroupSearchResultModel.read().ids = [];
          ngLargeCourseGroupSearchResultModel.clear().write({
            ids: []
          });
          deferred.resolve();
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/components/large_course_group/commands/clear_large_course_group_search_result_model.ts